import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PutApiProfileMutationRequest,
  PutApiProfileMutationResponse,
  PutApiProfile401,
  PutApiProfile403,
} from "../../../types/PutApiProfile";

export function getPutApiProfileUrl() {
  return `/api/Profile` as const;
}

/**
 * {@link /api/Profile}
 */
export async function putApiProfile(
  data?: PutApiProfileMutationRequest,
  config: Partial<RequestConfig<PutApiProfileMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PutApiProfileMutationResponse,
    ResponseErrorConfig<PutApiProfile401 | PutApiProfile403>,
    PutApiProfileMutationRequest
  >({
    method: "PUT",
    url: getPutApiProfileUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
